<template>
  <!--回复-->
  <div aria-labelledby="myModalLabel" class="modal fade" id="report" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="iconfont icon-close"></i>
          </button>
          <h4 class="modal-title" id="myModalLabel">被举报人：{{report.name}}（{{title}}）</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <textarea
              class="form-control"
              placeholder="举报内容……"
              style="resize: vertical;"
              rows="4"
              v-model="form.content"
              name="message"
              data-vv-as="举报内容 "
              v-validate="{ required:true, min:1,max:100 }"
            ></textarea>
            <span class="help-block" v-show="errors.has('message')">{{ errors.first('message') }}</span>
          </div>
          <div class="form-group">
            <select
              class="form-control"
              v-model="form.report_type"
              name="report_type"
              data-vv-as="举报类型 "
              v-validate="'required|included:1,2,3,4,0'"
            >
              <option v-for="type in types" :key="type.id" :value="type.id">{{type.content}}</option>
            </select>
            <span
              class="help-block"
              v-show="errors.has('report_type')"
            >{{ errors.first('report_type') }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">取消</button>
          <button class="btn btn-primary" type="button" @click="createReport">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createReport } from "@/api/topic/topic";
export default {
  name: "GroupReport",
  data() {
    return {
      form: {
        content: "",
        report_type: 1
      },
      types: [
        {
          id: 1,
          content: "传播危害国家安全、以及侮辱、诽谤、淫秽、暴力的内容"
        },
        { id: 2, content: "传播侵害他人名誉、知识产权等内容" },
        { id: 3, content: "虚构事实、误导、欺骗他人" },
        { id: 4, content: "发表、传播广告信息及垃圾信息" },
        { id: 0, content: "其他" }
      ]
    };
  },
  props: {
    report: {
      type: Object
    }
  },
  computed: {
    title() {
      if (this.report.report_object_type === "topic") {
        return "话题#" + this.report.report_object_number;
      }
      return "话题回复#" + this.report.report_object_number;
    }
  },
  methods: {
    createReport() {
      this.$validator.validate().then(valid => {
        if (valid) {
          createReport({
            report_object_number: this.report.report_object_number,
            report_object_type: this.report.report_object_type,
            report_content: this.form.content,
            report_type: this.form.report_type
          })
            .then(res => {
              if (res.status_code === 200) {
                $("#report").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message
                });
                this.form.content = "";
                this.form.report_type = "1";
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err
              });
            });
        }
      });
    }
  }
};
</script>

<style scoped>
</style>